import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import moment from 'moment'
import { FormattedMessage, injectIntl } from 'react-intl'

import {
  Select,
  Radio,
  RadioGroup,
  Input,
  InputDate,
  Textarea
} from 'components/fields'
import { MaterialModal } from 'components/layout'
import { Note, Title } from 'components/misc'
import { form } from 'helpers/decorators'
import { apiDashboard, apiCodeLists, apiConfiguration, apiAssessors } from 'helpers/decorators/api'
import { mapCategories } from 'helpers/mapForSelect'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import { SUBCATEGORIES } from 'constants/layout/setup-activity'
import validate from './setup-rp.validation'
import config from 'config'
import styles from './setup-rp.styl'
import { connect } from 'react-redux'
import assessorsDropdownSelector from '../../../../redux/selectors/assessors/assessorsDropdownSelector'
import { asyncValidate } from '../../../../models/residentialProjects/validateAssessor'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'


@injectIntl
@apiDashboard.apiResidentialProject({
  loaders: ['setup']
})
@apiCodeLists(['titles', 'projectLocationTypes'], {
  public: true
})

@apiConfiguration()
@apiAssessors()
@connect(({ api }) => ({
  dashboard: api.dashboard,
  assessor: api.assessor
}))
@form({
  form: 'setupResidentialProject',
  disableHook: true,
  validate,
  asyncValidate
})
class SetupRP extends Component {
  static propTypes = {
    id: PropTypes.any,
    onGetRPCategories: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSetupRP: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    setupStatus: PropTypes.object,
    codeLists: PropTypes.object,
    rPValues: PropTypes.object,
    values: PropTypes.object,
    params: PropTypes.object,
    colorClass: PropTypes.string,
    configuration: PropTypes.object,
    onGetConfigurationValue: PropTypes.func,
    assessor: PropTypes.object,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func,
    intl: PropTypes.object
  }

  static defaultProps = {}

  componentWillMount = async () => {
    await Promise.all([
      this.props.onGetRPCategories(),
    ])
    this.getAssessorsIfNecessary(this.getSubcategoryValue())
  }

  handleSubmit = fields => {
    const { params } = this.props

    this.props
      .onSetupRP(this.props.id, fields, { resetForm: this.props.reset })
      .then(() =>
        this.props.push(
          `${config.publicPath}/dashboard/awards/${params.awardId}/residential-project/${this.props
            .id}/report`
        )
      )
  }

  getAssessorsIfNecessary(subcategoryValue) {
    const orgId = this.getOrgId()
    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(this.props, 'initialValues'))

    if (isAssessorManagementEnabled && subcategoryValue && subcategoryValue !== 'others' && orgId) {
      this.props.onGetAvailableAssessorsForActivityCategory(orgId, subcategoryValue)
    }
  }

  clearSubCategory = () => this.props.change('helpers.subcategory', null)
  onSubCategoryChange = subcategoryValue => {
    this.getAssessorsIfNecessary(subcategoryValue)
    this.props.change('helpers.others', null)
    this.props.change('assessorId', null)
  }

  getOrgId() {
    return get(this.props, 'dashboard.awards.awards.data.organization.id')
  }
  getSubcategoryValue() {
    return get(this.props, 'values.helpers.subcategory')
  }
  render() {
    const {
      values,
      rPValues,
      codeLists,
      colorClass,
      setupStatus,
      handleSubmit,
      assessor
    } = this.props

    const rPCategories = rPValues.categories
    const categoryValue = get(values, 'helpers.category')
    const subcategoryValue = get(values, 'helpers.subcategory')
    const setupAssessorId = get(values, 'setupAssessorId')
    const categories = get(rPCategories, `['${ACTIVITY_SECTIONS.residential_project.id}'].categories`)
    const subCategories = get(rPCategories,      `['${ACTIVITY_SECTIONS.residential_project.id}'].subCategories`)
    const categoriesOptions = categories && mapCategories(categories)
    const subCategoriesOptions = subCategories && categoryValue ? mapCategories(subCategories[categoryValue]) : []
    const projectLocationTypes = get(codeLists, 'projectLocationTypes.list')
    const startDate =  get(values, 'startDate') && moment(get(values, 'startDate')).clone()
    const minEndDate = startDate && startDate.add(4, 'days')

    subCategoriesOptions.push(SUBCATEGORIES.others)

    const isAssessorManagementEnabled =  isAssessorManagementEnabledForActivity(get(this.props, 'initialValues'))
    const isOthersSubCategory = subcategoryValue === 'others'
    const isNoneOfTheseAssessor = setupAssessorId === 0
    const needHelpFromAwardLeader = setupAssessorId === -1
    const dropdownAssessors = assessorsDropdownSelector(assessor, false, this.props)
    const showAssessorFields = !isAssessorManagementEnabled || ((isAssessorManagementEnabled && !isOthersSubCategory) && (isAssessorManagementEnabled && !needHelpFromAwardLeader) && (isAssessorManagementEnabled && isNoneOfTheseAssessor))

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.activity_details"
            defaultMessage="Activity Details"
          />
        </Title>

        <div className="row">
          <div className="col-xs-12">
            <Select
              options={categoriesOptions}
              name="helpers.category"
              label="category"
              intlKey="label.category"
              onChange={this.clearSubCategory}
            />
          </div>
        </div>

        {categoryValue &&
          <div className="row">
            <div className="col-xs-12">
              <Select
                options={subCategoriesOptions}
                name="helpers.subcategory"
                label="Subcategory"
                intlKey="label.category"
                onChange={subcategoryValue => this.onSubCategoryChange(subcategoryValue)}
              />
            </div>
          </div>}

        {subcategoryValue === SUBCATEGORIES.others.value &&
          <div className="row">
            <div className="col-xs-12">
              <Input
                name="helpers.others"
                label="Please specify your category"
                intlKey="label.specify_category"
                maxLength={512}
              />
            </div>
          </div>}

        <div className="row">
          <div className="col-xs-12">
            <Textarea
              resizeable
              rows={3}
              name="goal"
              label="Goal"
              intlKey="label.goal"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <InputDate
              name="startDate"
              intlKey="label.start_date"
              label="Start Date"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <InputDate
              name="endDate"
              intlKey="label.end_date"
              label="End Date"
              minDay={minEndDate}
            />
          </div>
        </div>

        {projectLocationTypes &&
          Array.isArray(projectLocationTypes) &&
          projectLocationTypes[0] &&
          <RadioGroup
            label="Project Location"
            intlKey="label.project_location"
            name="projectLocationType.value"
            horizontal
            {...this.props}
          >
            {projectLocationTypes.map(item =>
              <Radio
                label={item.label}
                name="projectLocationType.value"
                value={item.value}
                key={item.value}
              />
            )}
          </RadioGroup>}

        <div className="row">
          <div className="col-xs-12">
            <Input
              name="locationDetail"
              label="Location"
              intlKey="label.location"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Textarea rows={2} name="note" label="Note" intlKey="label.note" />
          </div>
        </div>

        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.assessor_details"
            defaultMessage="Assessor Details"
          />
        </Title>

        {isAssessorManagementEnabled && <div>
          {!isOthersSubCategory && !needHelpFromAwardLeader && <div className={styles.selectAssessor} ><FormattedMessage
            id="label.select_award_unit_assessor"
            defaultMessage="Select from assessors already approved by your Award Unit or create a new one below."
          /></div>}

          {isOthersSubCategory && <div className={styles.assessorIsDisabled}><FormattedMessage
            id='label.assessor_disabled_for_other_activity'
            defaultMessage='Assessor selection is disabled for other activity.'
          /></div>}
          {!isOthersSubCategory && <div className="row">
            <div className="col-xs-12">
              <Select
                name='setupAssessorId'
                label=""
                intlKey=""
                options={dropdownAssessors}
                disabled={!subcategoryValue || isOthersSubCategory}
              />
            </div>
          </div>}
        </div>}

        {showAssessorFields && <div>
          <div className="row">
            <div className="col-xs-12">
              <Select
                name="assessorTitle"
                label="Title"
                intlKey="label.title"
                options={get(codeLists, 'titles.list')}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Input name="assessorName" label="name" intlKey="label.name" maxLength={100} />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Input
                name="assessorEmail"
                label="email"
                type="email"
                intlKey="label.email"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Input
                name="assessorPhone"
                label="Phone"
                type="phone"
                intlKey="label.phone"
              />
            </div>
          </div>
          {isNoneOfTheseAssessor && <div className="row">
            <div className="col-xs-12">
              <Note >
                <FormattedMessage
                  id="label.assessor_relevant_exp_desc"
                  defaultMessage="To help your Award Leader decide if this person is a viable Assessor, please provide some information about their experience in this activity e.g. coach."
                />
              </Note>
              <Textarea
                name="assessorRelevantExperience"
                label="Relevant Experience"
                intlKey="label.relevant_experience"
                maxLength={200}
              />
            </div>
          </div>}
        </div>}

        <MaterialModal.Footer
          action="Setup"
          actionType="button.setup"
          colorClass={colorClass}
          insideContent
          isLoading={get(setupStatus, 'loading')}
        />
      </form>
    )
  }
}

export default SetupRP
